import AjaxManager from '../ajaxManager';
import UserReview from '@web/web-components/user-review/src/userReview';
import LazyLoadManager from '../lazyLoadManager';
import * as Swiper from 'swiper';

export default class HotelReviewManager {
    constructor() {
        this.ajaxManager = new AjaxManager();
        this.reviewImageModal = document.querySelector('[data-gallery-modal="review-images-modal"]');
        this.eventDelegation();
        this.loading = false;
        this.sorterTypeSelected = null;
    }

    eventDelegation() {
        $('body').on('click', '[data-show-hotel-reviews]', (event) => {
            if (this.loading) {
                return;
            }
            this.loading = true;
            const currentTarget = event.currentTarget;
            const hotelId = currentTarget.getAttribute('data-show-hotel-reviews');
            const offset = currentTarget.getAttribute('data-offset');
            const maxResults = currentTarget.getAttribute('data-max-results');
            const isThematic = currentTarget.getAttribute('data-thematic');
            const reviewsContainer = currentTarget.closest('[data-entity="reviews"]')
            let selectedOrder = reviewsContainer.querySelector('[data-action="survey-order-change"]');
            if (selectedOrder) {
                selectedOrder = selectedOrder.value;
            } else {
                selectedOrder = null;
            }
            if (isThematic && myApp.groupThematicReviewManager) {
                myApp.groupThematicReviewManager.showReviews(hotelId, offset, maxResults, true, selectedOrder).then(() => {
                    this.loading = false;
                });
            } else {
                this.showReviews(hotelId, offset, maxResults, false, selectedOrder, reviewsContainer);
            }
        });

        document
            .querySelectorAll('[data-entity="reviews-with-photos"] [data-entity="swiper-slide"]')
            .forEach((element) => {
                element.addEventListener('click', (event) => {
                    if (!reviewImages || reviewImages.length === 0 || !imageReviews || imageReviews.length === 0) {
                        return;
                    }

                    const currentTarget = event.currentTarget;
                    const swiperImage = currentTarget.querySelector('[data-entity="swiper-image"]');
                    if (!swiperImage) {
                        return;
                    }

                    const index = parseInt(swiperImage.getAttribute('data-index'));
                    const imageIndex = parseInt(swiperImage.getAttribute('data-image-index'));
                    let userReview = this.createUserReview(index);

                    if (!userReview) {
                        return;
                    }

                    userReview = userReview._openReviewGallery(
                        imageIndex,
                        reviewImages.map((item) => item.image_url),
                        this.reviewImageModal,
                        currentTarget.classList.contains('swiper-slide-last'),
                    );

                    // Guardamos el color del alias para que siempre sea el mismo.
                    const userReviewId = userReview.getAttribute('user-review-id');
                    if (!userReviewId) {
                        return;
                    }

                    const currentUserReview = imageReviews.find((user) => user.id == userReviewId);
                    currentUserReview.avatarColor = userReview.avatarClasses;
                });
            });

        document.addEventListener('swiperSlideChanged', (e) => {
            if (!this.reviewImageModal || !this.reviewImageModal.shadowRoot) {
                return;
            }

            let userReviewContainer = this.reviewImageModal.shadowRoot.querySelector('user-review');
            if (!userReviewContainer) {
                return;
            }

            const imageGalleryList = userReviewContainer.imageGalleryList;
            if (!imageGalleryList) {
                return;
            }

            const activeIndex = e.detail;
            if (typeof activeIndex === 'undefined' || activeIndex === null || activeIndex < 0) {
                return;
            }

            const currentReview = reviewImages[activeIndex];
            if (!currentReview) {
                return;
            }

            // Guardamos el color del alias para que siempre sea el mismo.
            const currentUserReview = imageReviews.find((user) => user.id == currentReview.review_id);
            if (!currentUserReview.avatarColor) {
                currentUserReview.avatarColor = userReviewContainer.avatarClasses;
            }

            if (currentReview.review_id == userReviewContainer.getAttribute('user-review-id')) {
                return;
            }

            const userReview = userReviewContainer._createUserReviewGalleryList(
                currentUserReview,
            );

            userReviewContainer = userReviewContainer.parentElement;
            userReviewContainer.innerHTML = '';
            userReviewContainer.appendChild(userReview);

            const userReviewContent = userReview._shadowRoot;
            if (userReviewContent) {
                const userReviewAlias = userReviewContent.querySelector('[name="alias-summary"]');
                if (userReviewAlias && currentUserReview.avatarColor) {
                    userReviewAlias.className = currentUserReview.avatarColor;
                }
            }

            if (imageGalleryList) {
                imageGalleryList._addGalleryModalDarkMode();
            }
        });

        const reviewsSorter = document.querySelectorAll('[data-action="survey-order-change"]');
        if (reviewsSorter.length > 0) {
            reviewsSorter.forEach((element) => {
                element.addEventListener('change', (event) => {
                    this.changeReviewsOrder(element, event.target.value);
                })
            });
        }

        window.addEventListener('load', () => {
            const userReviews = document.querySelectorAll('user-review');
            this.setCommnetClick(userReviews);
        });
    }

    changeReviewsOrder(element, sorterTypeSelected) {
        const reviewsContainer = element.closest('[data-entity="reviews"]');
        if (!reviewsContainer) return;
        const container = reviewsContainer.querySelector('[data-reviews-container]');
        if (!container) return;

        const skeleton = reviewsContainer.querySelector('[data-entity="reviews-skeleton"]');
        container.innerHTML = '';
        container.classList.add('d-none');
        if (skeleton) {
            skeleton.classList.remove('hidden');
        }

        const sorterReviewData = reviewsContainer.querySelector('[data-sorter-show-reviews]');
        if (sorterReviewData && sorterReviewData.getAttribute('data-thematic') && myApp.groupThematicReviewManager) {
            myApp.groupThematicReviewManager.showReviews(sorterReviewData.getAttribute('data-sorter-show-reviews'), sorterReviewData.getAttribute('data-offset'),
                sorterReviewData.getAttribute('data-max-results'), true, sorterTypeSelected).then(() => {
                this.loading = false;
                skeleton.classList.add('hidden');
                container.classList.remove('d-none');
            });
            const thematicReviews = document.querySelectorAll('user-review');
            this.setCommnetClick(thematicReviews);
        } else {
            this.showReviews(sorterReviewData.getAttribute('data-sorter-show-reviews'), sorterReviewData.getAttribute('data-offset'),
                sorterReviewData.getAttribute('data-max-results'), true, sorterTypeSelected, reviewsContainer, container, skeleton);
        }
    }


    showReviews(hotelId, offset, maxResults, sort = false, sorterTypeSelected = null, dataContainer, reviewsContainer = null, skeleton = null) {
        let url = myApp.config.routing.hotelReviewShow;
        let data = {
            hotelId: hotelId,
            offset: offset,
            maxResults: maxResults,
            sortType: sorterTypeSelected
        };

        const loader = dataContainer.querySelector('[data-show-hotel-reviews="' + hotelId + '"] [data-loader]');
        if (loader) {
            loader.style.display = 'block';
        }
        let callback = (reviewView) => {
            const hotelReviewsContainer = dataContainer.querySelector('[data-show-hotel-reviews="' + hotelId + '"]');
            if (hotelReviewsContainer) {
                hotelReviewsContainer.remove();
            }
            dataContainer.querySelector('[data-reviews-container="' + hotelId + '"]').innerHTML += reviewView;
            if (sort) {
                if (skeleton) {
                    skeleton.classList.add('hidden');
                }

                if (reviewsContainer) {
                    reviewsContainer.classList.remove('d-none');
                }
            }
            this.loading = false;
            const userReviews = document.querySelectorAll('user-review');
            this.setCommnetClick(userReviews);
            userReviews.forEach((element) => {
                element.setSwiper(Swiper);
            });
        };

        this.ajaxManager.ajaxCall('POST', url, data, callback);
    }

    createUserReview(index) {
        const reviewId = reviewImages[index].review_id;
        if (!reviewId) {
            return;
        }
        const genericUserReview = document.querySelector('user-review');
        const userReview = new UserReview();
        userReview.setSwiper(Swiper);

        const hotelInfo = genericUserReview.getAttribute('hotel-info');
        if (hotelInfo) {
            userReview.setAttribute('hotel-info', hotelInfo);
        }
        userReview.setAttribute('translations', genericUserReview.getAttribute('translations'));
        userReview.setAttribute('stylesheet', genericUserReview.getAttribute('stylesheet'));
        userReview.setAttribute(
            'user-review',
            JSON.stringify(imageReviews.find((imageReview) => imageReview.id === reviewId)),
        );
        userReview.setAttribute('user-review-id', reviewId);
        return userReview;
    }

    setCommnetClick(reviewElements) {
        reviewElements.forEach((review) => {
            if (!review.getAttribute('activityId')) {
                review.translateCommentClick = this.translateComment.bind(this);
            }
        });
    }

    translateComment(reviewId, userReview) {
        const url = myApp.config.routing.hotelReviewTranslateComment;
        let data = {
            reviewId: reviewId,
            reviewWebId: userReview.getAttribute('review-web')
        };

        let callback = (response) => {
            if (response.status == 200 && response.review && userReview) {
                const userReviewData = response.review;
                userReview._fillTranslatedComments(userReview, userReviewData);
                userReview._toggleOriginalComment(
                    userReview._shadowRoot.querySelector('[name="user-comments-container"]'),
                    'none',
                    'block'
                );
            } else {
                return
            }
        };

        this.ajaxManager.ajaxCall('POST', url, data, callback);
    }
}
